export type Lang = "en" | "fr" | "pt";

export const translations: Record<Lang, Record<string, string>> = {
  en: {
    // ── Brand & shared ──
    brand_loc: "Dzaleka - Dowa, P.O. Box 16, Malawi | Fraternity Without Borders",
    footer_collab: "In Collaboration with",
    footer_copy: "© 2026 Nation Ubuntu School | Dzaleka - Dowa, P.O. Box 16 Malawi.",
    loading_portal: "Loading Nation Ubuntu School Portal...",
    role_admin: "Administrator",
    role_staff: "Staff",
    role_teacher: "Teacher",
    role_guardian: "Guardian",
    lang_en: "English",
    lang_fr: "Français",
    lang_pt: "Português (Brasil)",

    // ── Nav labels ──
    nav_reg: "Student Registration",
    nav_certs: "Certificates & Reports",
    nav_caravana: "Caravana for School",
    nav_contact: "Contact & Safety",
    nav_admin: "Management",
    nav_school_mgmt: "Academics",
    nav_attendance: "Attendance",
    nav_dashboard: "Dashboard",
    nav_overview: "Daily Overview",
    nav_logout: "Sign Out",

    // ── Common labels ──
    lbl_all: "All",
    lbl_all_schools: "All Schools",
    lbl_all_classes: "All Classes",
    lbl_all_departments: "All Departments",
    lbl_select_school: "Select School",
    lbl_person_type: "Person Type",
    lbl_gender: "Gender",
    lbl_class: "Class",
    lbl_department: "Department",
    lbl_date_from: "Date From",
    lbl_date_to: "Date To",
    opt_female: "Female",
    opt_male: "Male",
    opt_students: "Students",
    opt_volunteers: "Volunteers",
    opt_volunteers_staff: "Volunteers/Staff",
    btn_clear_filters: "Clear Filters",
    lbl_present: "Present",
    lbl_absent: "Absent",
    lbl_justified: "Justified",
    lbl_total_records: "Total Records",
    lbl_present_rate: "Present Rate",
    lbl_date: "Date",
    lbl_name: "Name",
    lbl_type: "Type",
    lbl_class_dept: "Class/Dept",
    lbl_level: "Level",
    lbl_shift: "Shift",
    lbl_status: "Status",
    lbl_justification: "Justification",
    lbl_item: "Item",
    lbl_description: "Description",
    lbl_quantity: "Quantity",
    lbl_destination: "Destination",
    lbl_collector: "Collector",
    lbl_search_name: "Search by Name",
    ph_search_name: "Search person name...",

    // ── Auth page ──
    auth_signin_title: "Sign In",
    auth_register_title: "Create Account",
    auth_verify_title: "Verify Your Email",
    auth_back_home: "Back to Home",
    auth_back_signin: "Back to sign in",
    auth_welcome: "Welcome back to Nation Ubuntu School Portal",
    auth_register_desc: "Register for the Nation Ubuntu School Portal",
    lbl_email: "Email",
    lbl_password: "Password",
    lbl_full_name: "Full Name",
    lbl_confirm_password: "Confirm Password",
    lbl_account_type: "Account Type",
    opt_guardian: "Guardian / Parent",
    opt_staff: "Staff",
    opt_teacher: "Teacher",
    opt_admin: "Admin (requires approval)",
    ph_email: "you@example.com",
    ph_password: "Enter your password",
    ph_full_name: "Enter your full name",
    ph_create_password: "Create a password (min 6 chars)",
    ph_confirm_password: "Re-enter your password",
    ph_verify_code: "000000",
    lbl_verify_code: "Verification Code",
    verify_desc: "Enter the 6-digit code sent to",
    verify_hint: "The code expires in 10 minutes.",
    btn_sign_in: "Sign In",
    btn_signing_in: "Signing in...",
    btn_register: "Register",
    btn_sending: "Sending...",
    btn_verify: "Verify & Create Account",
    btn_verifying: "Verifying...",
    or_signin_with: "OR SIGN IN WITH",
    no_account: "Don't have an account?",
    register_here: "Register here",
    have_account: "Already have an account?",
    signin_link: "Sign in",
    resend_code: "Didn't receive a code? Resend",
    admin_approval_note: "Admin accounts require approval. An email will be sent to the administrator for review.",
    verify_code_note: "A verification code will be sent to your email. You must enter it within 10 minutes to complete registration.",
    err_recaptcha: "Please complete the reCAPTCHA verification.",
    err_invalid_credentials: "Invalid email or password. Please try again.",
    err_password_mismatch: "Passwords do not match. Please confirm your password.",
    err_password_short: "Password must be at least 6 characters long.",
    err_confirm_mismatch: "Passwords do not match.",
    err_passwords_match: "Passwords match",
    err_registration_failed: "Registration failed. Please try again.",
    err_verification_failed: "Verification failed.",
    err_resend_failed: "Failed to resend code.",
    err_unexpected: "An unexpected error occurred. Please try again.",
    err_unexpected_verify: "An unexpected error occurred during verification.",
    err_google_signin: "Google sign-in failed. Please try again.",
    err_facebook_signin: "Facebook sign-in failed. Please try again.",
    msg_admin_request: "Admin approval request sent! An email has been sent to the administrator. You will receive your credentials once approved.",
    msg_verify_sent: "A verification code has been sent to your email. It expires in 10 minutes.",
    msg_verify_code_prefix: "Your verification code is:",
    msg_account_created: "Account created successfully! You can now log in with your credentials.",
    msg_resend_sent: "A new verification code has been sent to your email.",
    msg_resend_code_prefix: "Your new verification code is:",

    // ── Change password ──
    pw_change_title: "Change Your Password",
    pw_change_desc: "This is your first login. You must set a new password.",
    lbl_new_password: "New Password",
    lbl_confirm_new_password: "Confirm New Password",
    ph_new_password: "Enter new password (min 6 chars)",
    ph_confirm_new_password: "Confirm new password",
    btn_change_password: "Change Password",
    btn_changing: "Changing...",
    pw_changed_title: "Password Changed!",
    pw_changed_desc: "Your password has been updated successfully. You can now continue using the portal.",
    btn_continue: "Continue to Portal",
    err_change_password: "Failed to change password. Please try again.",

    // ── Student Registration ──
    reg_title: "New Student Registration",
    reg_desc: "Register a new student. Assign them to a class and shift.",
    lbl_reg_name: "Student Full Name",
    lbl_reg_dob: "Date of Birth",
    lbl_reg_gender: "Gender",
    lbl_reg_level: "Applying For Level",
    lbl_reg_shift: "Shift",
    lbl_reg_class: "Assign to Class",
    lbl_reg_guardian: "Parent / Guardian Name",
    lbl_reg_phone: "Contact Phone / WhatsApp",
    lbl_reg_email: "Guardian Email (optional)",
    opt_level_preschool: "Pre-School",
    opt_level_primary: "Primary School",
    opt_level_secondary: "Secondary School",
    opt_shift_morning: "Morning Shift",
    opt_shift_afternoon: "Afternoon Shift",
    opt_no_class: "No class assigned",
    btn_submit_reg: "Submit Registration",
    btn_saving: "Saving...",
    reg_success_title: "Registration Submitted Successfully!",
    reg_ref_code: "Application Reference Code",
    reg_success_msg: "The student has been registered and can now have attendance recorded.",
    err_reg_save: "Could not save the student registration. Please try again.",
    reg_list_title: "Registered Students",
    reg_list_empty: "No students registered yet.",
    ph_school_select: "Select a school...",
    ph_reg_name: "e.g. Marie Uwase",
    ph_reg_guardian: "e.g. Jean Bosco",
    ph_reg_phone: "+265...",
    ph_reg_email: "guardian@example.com",

    // ── Dashboard ──
    dash_title: "Admin Dashboard",
    dash_tab_overview: "Overview",
    dash_tab_attendance: "Attendance Tracker",
    dash_tab_activity: "Activity Log",
    dash_total_students: "Total Students",
    dash_total_volunteers: "Total Volunteers",
    dash_attendance_today: "Attendance Today",
    dash_transfers: "Transfers",
    dash_recent_activity: "Recent Activity",
    dash_full_activity_log: "Full Activity Log",
    dash_no_activity: "No activity recorded yet.",
    dash_no_attendance: "No attendance records match the selected filters.",
    dash_no_logs: "No activity logs found.",
    dash_unknown: "Unknown",
    dash_just_now: "just now",
    dash_min_ago: "m ago",
    dash_hr_ago: "h ago",
    dash_day_ago: "d ago",
    ph_search_activity: "Search by action, user, entity, or details...",

    // ── Attendance Dashboard ──
    att_title: "Attendance Overview & Filtering",
    att_desc: "View and filter attendance records. Saturdays and Sundays are automatically skipped.",
    att_filter_title: "Filter Attendance",
    att_lbl_class_level: "Class Level (Students)",
    att_lbl_dept_volunteers: "Department (Volunteers)",
    att_loading: "Loading attendance records...",
    att_no_records: "No attendance records found with the current filters.",
    att_weekend: "Weekend (Skipped)",
    opt_level_preschool_short: "Pre-School",
    opt_level_primary_short: "Primary",
    opt_level_secondary_short: "Secondary",
    dept_sanitation: "Sanitation",
    dept_maintenance: "Maintenance",

    // ── Management ──
    mgmt_tab_store: "Store",
    mgmt_tab_food: "Food",
    mgmt_tab_media: "Media",
    mgmt_tab_transfers: "Transfers",
    mgmt_tab_schools: "Schools",
    store_title: "Store Management",
    store_entry_reg: "Store Entry Registration",
    store_exit_reg: "Store Exit Registration",
    store_stock_title: "Stock (Automatic Inventory: Entries minus Exits)",
    store_stock_desc: "Calculated automatically: stock = all entries of the same item minus all exits of the same item.",
    store_no_inventory: "No inventory data available yet.",
    store_all_entries: "All Entered Items",
    store_no_entries: "No entries logged yet.",
    store_all_exits: "All Exited Items",
    store_no_exits: "No exits logged yet.",
    btn_entry: "Entry",
    btn_exit: "Exit",
    btn_stock: "Stock",
    btn_record_entry: "Record Entry",
    btn_record_exit: "Record Exit",
    store_entries: "Entries:",
    store_exits: "Exits:",
    store_stock: "Stock:",
    ph_item: "e.g. Notebooks",
    ph_desc: "e.g. 100 pages ruled",
    ph_qty_num: "e.g. 50",
    ph_dest: "e.g. Primary Grade 1",
    food_title: "Food Management",
    food_ubuntu: "Ubuntu School",
    food_eagles: "Eagles School",
    food_bakery: "Bakery",
    food_ubuntu_title: "Ubuntu School Food Distribution",
    food_eagles_title: "Eagles School Food Distribution",
    food_bakery_title: "Bakery Management",
    lbl_item_meal: "Item / Meal",
    lbl_qty_str: "Quantity",
    lbl_receiver_details: "Receiver / Details",
    btn_insert_ubuntu: "Insert Ubuntu Food Record",
    btn_insert_eagles: "Insert Eagles Food Record",
    btn_insert_bakery: "Insert Bakery Record",
    food_no_records: "No records yet.",
    food_qty: "Qty:",
    food_details: "Details:",
    food_item: "Item:",
    food_collector: "Collector:",
    food_date: "Date:",
    ph_food_ubuntu: "e.g. Likuni Phala",
    ph_food_ubuntu_qty: "e.g. 25 kg",
    ph_food_ubuntu_details: "e.g. Pre-school children",
    ph_food_eagles: "e.g. Rice & Beans",
    ph_food_eagles_qty: "e.g. 30 kg",
    ph_food_eagles_details: "e.g. Primary students",
    ph_bakery_item: "e.g. Bread loaves",
    ph_bakery_qty: "e.g. 50",
    ph_bakery_collector: "e.g. John Doe",
    media_title: "Media Management",
    media_entry_title: "Media Equipment Entry",
    media_exit_title: "Media Equipment Exit",
    media_inventory_title: "Automatic Inventory (Entry minus Exit)",
    media_inventory_desc: "Calculated automatically based on logged media entries and exits.",
    media_no_inventory: "No media inventory data yet.",
    media_no_entries: "No media entries yet.",
    media_no_exits: "No media exits yet.",
    btn_add_media_entry: "Add Media Entry",
    btn_add_media_exit: "Add Media Exit",
    btn_auto_inventory: "Automatic Inventory",
    media_current_balance: "Current Balance:",
    ph_media_item: "e.g. DSLR Cameras",
    ph_media_desc: "e.g. Canon with lens",
    ph_media_qty: "e.g. 3",
    transfers_title: "Transfer Materials Between Schools",
    transfers_desc: "Record materials transferred from one school to another. This keeps each school's inventory separate.",
    lbl_from_school: "From School",
    lbl_to_school: "To School",
    ph_select_source: "Select source...",
    ph_select_dest: "Select destination...",
    btn_record_transfer: "Record Transfer",
    transfers_all: "All Transfers",
    transfers_none: "No transfers recorded yet.",
    lbl_from: "From",
    lbl_to: "To",
    lbl_qty: "Qty",
    schools_title: "School Management",
    schools_desc: "Add and manage schools. Students and volunteers registered in one school are kept separate from others.",
    lbl_school_name: "School Name",
    lbl_location: "Location",
    lbl_school_desc: "Description",
    btn_add_school: "Add School",
    schools_all: "All Schools",
    schools_none: "No schools added yet.",
    ph_school_name: "e.g. Nation Ubuntu School",
    ph_location: "e.g. Dzaleka - Dowa",
    ph_school_desc: "e.g. Main campus",

    // ── Academics (existing keys kept) ──
    nav_logout_dup: "Sign Out",
    reg_desc_old: "Please fill out the form completely and upload the required verification documents, student identification, and picture.",
    lbl_reg_photo: "Student Passport Photograph",
    lbl_photo_hint: "Clear headshot picture of the student applying (JPG, PNG)",
    lbl_reg_id_doc: "Identification Document (ID / Refugee Card / Birth Certificate)",
    lbl_id_hint: "Upload a scan or photo of the identification document",
    btn_submit_app: "Submit Application",
    reg_success_msg_old: "Your application documents, student identification, and picture have been securely uploaded. The admissions committee at Dzaleka will review your file and reach out via contact phone.",
    cert_title: "Certificate Authenticity & Document Downloads",
    cert_desc: "Check the genuineness of certificates issued by Nation Ubuntu School and download official term reports.",
    lbl_certno: "Certificate Serial Number / Report ID",
    lbl_doctype: "Document Type",
    opt_report: "Academic Report Card",
    opt_cert: "Certificate of Completion",
    opt_conduct: "Letter of Recommendation",
    lbl_dlformat: "Download Copy Format",
    opt_pdf: "Official PDF Document",
    opt_seccopy: "Certified Secure Copy (Digital Seal)",
    opt_printcopy: "Print-Ready Clean Copy",
    btn_checkdoc: "Verify & Find Document",
    doc_verified: "Document Verified Genuine",
    doc_title: "Document Title",
    doc_title_val: "Pre-School / Primary / Secondary Leaving Certificate of Completion",
    doc_issued: "Issued To",
    doc_issued_val: "Nation Ubuntu Student",
    doc_stamp: "Institution Stamp",
    doc_stamp_val: "Nation Ubuntu School - Dzaleka Camp",
    btn_download_pdf: "Download Official PDF",
    btn_download_copy: "Download Certified Copy",
    msg_title: "Message Administration & Safety Team",
    lbl_recipient: "Send Message To",
    opt_preschool: "Pre-School Coordinator",
    opt_primary: "Primary School Principal",
    opt_secondary: "Secondary School Principal",
    opt_safety: "School Safety & Protection Team",
    lbl_sendername: "Your Full Name",
    lbl_contactinfo: "Phone Number or Email",
    lbl_msgbody: "Message Content",
    btn_sendmsg: "Send Secure Message",
    sm_main_title: "Academics: Attendances & Classes",
    sm_main_desc: "Manage shift-based academic departments, manual volunteer/worker entry, separated pre-school/primary class lists, and housekeeping attendances.",
    sm_tab1: "1. Academic (Shift & Department)",
    sm_tab2: "2. Classes (Pre-School & Primary)",
    sm_tab3: "3. Attendance Housekeeping",
    acad_sub_title: "Academic Shifts & Department Registers",
    lbl_acad_shift: "Select Shift",
    lbl_acad_dept: "Select Department",
    dept_admin: "Administration",
    dept_teachers_preschool: "Teachers (Pre-School)",
    dept_teachers_primary: "Teachers (Primary)",
    dept_psychosocial: "Psycho-Social",
    dept_media: "Media",
    dept_safety: "School Safety",
    lbl_acad_worker: "Insert Volunteer / Worker Name Manually",
    btn_add: "Add",
    acad_roster_title: "Active Shift Roster",
    acad_all_names: "All Inserted Names",
    classes_sub_title: "Class Registers & Teacher Assignments",
    lbl_class_session: "Select Shift / Session",
    lbl_class_level: "Select Level",
    lbl_class_name: "Insert Class Name",
    btn_create_class: "Create Class",
    lbl_active_class: "Select Active Class",
    lbl_teacher_name: "Manually Insert Teacher's Name",
    lbl_assistant_name: "Manually Insert Assistant Teacher's Name",
    h4_add_student: "Manually Insert Student Name",
    btn_add_student: "Add Student",
    h4_student_register: "Student Register for",
    house_sub_title: "Attendance Housekeeping",
    lbl_house_dept: "Select Department",
    lbl_house_newdept: "Insert Department Name Manually",
    btn_add_dept: "Add Dept",
    lbl_house_worker: "Manually Insert Volunteer / Worker Name",
    btn_add_worker: "Add Worker",
    h4_house_roster: "Housekeeping Roster for",
    ph_certno: "e.g. NUS-CERT-2025-998",
    ph_sendername: "Enter your full name",
    ph_contactinfo: "+265...",
    ph_msgbody: "Write your message or report here...",
    ph_worker: "Enter name of volunteer/worker...",
    ph_classname: "e.g. Class A / Grade 1",
    ph_teacher: "Enter teacher's name...",
    ph_assistant: "Enter assistant teacher's name...",
    ph_student: "Enter student full name...",
    ph_dept: "Enter new department...",
    ph_worker_h: "Enter name of volunteer/worker...",

    // ── HomePage ──
    hp_login: "Login",
    hp_portal_login: "Portal Login",
    hp_learn_more: "Learn More",
    hp_hero_badge: "Fraternity Without Borders",
    hp_hero_title: "Education for a Brighter Future",
    hp_hero_desc: "Nation Ubuntu School is a community-driven educational institution in the Dzaleka Refugee Camp, dedicated to providing quality education from pre-school through secondary school for children in need.",
    hp_stat_students: "Students Enrolled",
    hp_stat_levels: "Education Levels",
    hp_stat_volunteers: "Volunteers",
    hp_stat_years: "Years of Service",
    hp_about_title: "About Our School",
    hp_about_desc: "Located in the heart of Dzaleka Camp, we serve refugee and local children with comprehensive education across three levels.",
    hp_preschool_title: "Pre-School",
    hp_preschool_desc: "Early childhood education that builds foundational literacy, numeracy, and social skills for our youngest learners.",
    hp_primary_title: "Primary School",
    hp_primary_desc: "Comprehensive primary education following a structured curriculum that prepares students for secondary education and beyond.",
    hp_secondary_title: "Secondary School",
    hp_secondary_desc: "Advanced secondary education that equips students with knowledge and certificates to pursue higher education or vocational paths.",
    hp_mission_title: "Our Mission & Values",
    hp_mission_desc: "We believe every child deserves access to quality education, regardless of their background or circumstances.",
    hp_value_compassion: "Compassion",
    hp_value_compassion_desc: "We treat every child with dignity, kindness, and respect, fostering a nurturing environment for growth.",
    hp_value_safety: "Safety",
    hp_value_safety_desc: "We provide a secure and protective environment where children can learn and thrive without fear.",
    hp_value_community: "Community",
    hp_value_community_desc: "We build strong partnerships with families, volunteers, and organizations to support every student's journey.",
    hp_contact_title: "Get in Touch",
    hp_contact_desc: "Have questions about enrollment, donations, or volunteering? We'd love to hear from you.",
    hp_contact_loc1: "Dzaleka - Dowa",
    hp_contact_loc2: "P.O. Box 16, Malawi",
    hp_contact_email: "info@nationubuntu.org",
    hp_contact_hours1: "Mon - Fri",
    hp_contact_hours2: "7:00 AM - 4:00 PM",
    hp_access_portal: "Access Portal",

    // ── Academics ──
    acad_title: "Academics: Attendances & Classes",
    acad_desc: "Manage shift-based academic departments, volunteer/worker entry, class lists, and housekeeping attendance.",
    acad_attendance_date: "Attendance Date",
    acad_weekend_warning: "Weekend detected - attendance is skipped for Saturdays and Sundays.",
    acad_btn_edit: "Edit",
    acad_btn_delete: "Delete",
    acad_btn_present: "Present",
    acad_btn_absent: "Absent",
    acad_btn_justified: "Justified",
    acad_btn_not_justified: "Not Justified",
    acad_no_workers: "No volunteers/workers added to",
    acad_no_workers2: "for the",
    acad_no_workers3: "shift yet.",
    acad_no_students: "No students added yet.",
    acad_no_house_workers: "No volunteers/workers added to",
    acad_no_house_workers2: "yet.",
    acad_must_change_password: "must_change_password",
    acad_roster_shift: "Shift",
    acad_opt_morning: "Morning",
    acad_opt_afternoon: "Afternoon",
    acad_opt_preschool: "Pre-School",
    acad_opt_primary: "Primary",
    acad_btn_create: "Create",
    acad_h4_add_student: "Add Student",
    acad_student_register_none: "None",
    acad_weekend_alert: "Attendance cannot be recorded on weekends (Saturday/Sunday). Please select a weekday.",

    // ── PublicSections ──
    cert_alert: "Please enter a valid Certificate / Report ID",
    cert_download_pdf_alert: "Preparing official PDF download",
    cert_download_copy_alert: "Preparing certified secure copy download",
    msg_err_send: "Could not send message. Please try again.",
    msg_success_prefix: "Your message has been sent to the",
    msg_success_suffix: "Thank you.",
    msg_btn_sending: "Sending...",
    caravana_donate_monetary_alert: "Opening Secure Monetary Donation Portal (Mobile Money / Bank Transfer / Credit Card via Fraternity Without Borders)...",
    caravana_donate_material_alert: "Thank you! Please specify educational books, uniforms, or sports gear donations by contacting our Dzaleka logistics coordinator.",
    caravana_donate_voluntary_alert: "Thank you for offering your Voluntary Service! Our Caravana team will reach out to coordinate your schedule.",
    caravana_banner_title: "Caravana for School",
    caravana_banner_sub: "Fraternity Without Borders - Nation Ubuntu School Initiative",
    caravana_what_title: "What is the Caravana for School Project?",
    caravana_intro: "The Caravana for School project unites international expats—including Brazilians, Americans, and volunteers worldwide—who travel to Dzaleka to work side-by-side with local educators and students. Their contributions include:",
    caravana_list1: "Interactive Teaching & Extracurriculars: Introducing creative arts, music, languages, and engaging learning games.",
    caravana_list2: "Teacher Capacity Building: Sharing modern pedagogical techniques, classroom management strategies, and trauma-informed teaching approaches.",
    caravana_list3: "Resource Mobilization: Channeling much-needed school supplies, books, sports gear, and financial contributions to the school.",
    caravana_list4: "Sports & Recreational Programming: Using structured physical education to heal trauma, build teamwork, and promote physical health.",
    caravana_ubuntu_title: "The Philosophy of Ubuntu in Action",
    caravana_ubuntu_desc: "The operational heart of Caravana is the philosophy of Ubuntu—\"I am because we are.\" When international volunteers live, work, and laugh with refugee children in Dzaleka, they convey a powerful message: You are seen, valued, and matter to the wider world. For children who have experienced forced migration, this global validation restores human dignity and teaches that compassion knows no borders.",
    caravana_pillars_title: "Core Pillars of Importance",
    caravana_pillar1: "Bridging Resource Gaps: By mobilizing international networks, the project supplies essential notebooks, textbooks, and learning tools.",
    caravana_pillar2: "Elevating Educator Excellence: Through collaborative workshops and peer mentoring, local teachers gain practical tools to manage multi-level classrooms.",
    caravana_pillar3: "Fostering Psychosocial Well-Being: Play-based learning, sports, and art provide safe psychological outlets, helping children process trauma.",
    caravana_pillar4: "Expanding Cultural Horizons: Exposure to international volunteers sparks student ambition, while volunteers return home with first-hand insights.",
    caravana_impact_title: "Transformative Community Impact",
    caravana_impact_desc: "The impact of the Caravana project ripples across the entire community. Students exhibit higher engagement, improved attendance, and renewed confidence in their futures. Local teachers experience professional renewal and reduced burnout, leaving sustainable teaching methods embedded within the school long after volunteers depart. Furthermore, shared sports tournaments and collaborative classrooms break down \"us versus them\" mentalities, forging deep trust between refugees and the host community.",
    caravana_conclusion_title: "Conclusion",
    caravana_conclusion_desc: "The Caravana for School project is a powerful manifestation of human solidarity and active hope. By uniting international supporters and local communities under the banner of Ubuntu, the initiative proves that education is a collective responsibility. Nation Ubuntu School continues to demonstrate that human potential knows no limits when nurtured with love, community, and shared purpose.",
    caravana_support_title: "Support Our Mission - Choose Contribution Type",
    caravana_donate_monetary: "Donate: Monetary",
    caravana_donate_material: "Donate: Material",
    caravana_voluntary: "Voluntary Service",

    // ── ExcelBulkUpload ──
    bulk_upload_btn: "Bulk Upload",
    bulk_upload_title: "Bulk Upload",
    bulk_upload_desc: "Upload an Excel file (.xlsx or .csv) to register multiple entries at once. The columns must match the template below. All entries will be saved to the currently selected school.",
    bulk_download_template: "Download Template",
    bulk_template_desc: "Use this template to ensure your columns match. Fill in the rows and upload the file.",
    bulk_download_btn: "Download Template",
    bulk_drag_drop: "Drag & drop your Excel file here",
    bulk_or_browse: "or click to browse",
    bulk_selected: "Selected:",
    bulk_or_choose: "or click below to choose a different file",
    bulk_choose_file: "Choose File",
    bulk_parsing: "Parsing",
    bulk_preview: "Preview",
    bulk_rows: "rows",
    bulk_valid: "valid",
    bulk_with_errors: "with errors",
    bulk_status: "Status",
    bulk_ok: "OK",
    bulk_upload_btn2: "Upload",
    bulk_to_database: "to Database",
    bulk_uploading: "Uploading...",
    bulk_select_school_warn: "Please select a school before uploading.",
    bulk_success: "Successfully Saved",
    bulk_failed: "Failed / Skipped",
    bulk_errors: "Errors:",
    bulk_upload_another: "Upload Another File",
    bulk_done: "Done",
    bulk_empty_file: "The Excel file is empty or has no data rows.",
    bulk_read_error: "Could not read the Excel file. Please ensure it is a valid .xlsx or .csv file.",
    bulk_file_error: "Failed to read the file.",
    bulk_db_error: "Database error:",
    bulk_row: "Row",
    bulk_is_required: "is required",
    bulk_gender_err: "Gender must be 'female' or 'male'",
    bulk_level_err: "Level must be preschool, primary, or secondary",
    bulk_shift_err: "Shift must be 'morning' or 'afternoon'",
    bulk_category_err: "Category must be 'academic' or 'housekeeping'",
    bulk_col_full_name: "Full Name",
    bulk_col_dob: "Date of Birth",
    bulk_col_gender: "Gender",
    bulk_col_level: "Level",
    bulk_col_guardian_name: "Guardian Name",
    bulk_col_guardian_phone: "Guardian Phone",
    bulk_col_guardian_email: "Guardian Email",
    bulk_col_shift: "Shift",
    bulk_col_department: "Department",
    bulk_col_category: "Category",
    bulk_col_housekeeping_dept: "Housekeeping Dept",
    bulk_entity_student: "Student",
    bulk_entity_volunteer: "Volunteer",
  },

  // ════════════════════════════ FRENCH ════════════════════════════
  fr: {
    brand_loc: "Dzaleka - Dowa, P.O. Box 16, Malawi | Fraternité Sans Frontières",
    footer_collab: "En collaboration avec",
    footer_copy: "© 2026 Nation Ubuntu School | Dzaleka - Dowa, P.O. Box 16 Malawi.",
    loading_portal: "Chargement du portail Nation Ubuntu School...",
    role_admin: "Administrateur",
    role_staff: "Personnel",
    role_teacher: "Enseignant",
    role_guardian: "Tuteur",
    lang_en: "English",
    lang_fr: "Français",
    lang_pt: "Português (Brasil)",

    nav_reg: "Inscription des Élèves",
    nav_certs: "Certificats et Rapports",
    nav_caravana: "Caravana pour l'École",
    nav_contact: "Contact et Sécurité",
    nav_admin: "Gestion",
    nav_school_mgmt: "Académique",
    nav_attendance: "Présences",
    nav_dashboard: "Tableau de Bord",
    nav_overview: "Aperçu Quotidien",
    nav_logout: "Déconnexion",

    lbl_all: "Tous",
    lbl_all_schools: "Toutes les Écoles",
    lbl_all_classes: "Toutes les Classes",
    lbl_all_departments: "Tous les Départements",
    lbl_select_school: "Sélectionner l'École",
    lbl_person_type: "Type de Personne",
    lbl_gender: "Sexe",
    lbl_class: "Classe",
    lbl_department: "Département",
    lbl_date_from: "Date De",
    lbl_date_to: "Date À",
    opt_female: "Féminin",
    opt_male: "Masculin",
    opt_students: "Élèves",
    opt_volunteers: "Bénévoles",
    opt_volunteers_staff: "Bénévoles/Personnel",
    btn_clear_filters: "Effacer les Filtres",
    lbl_present: "Présent",
    lbl_absent: "Absent",
    lbl_justified: "Justifié",
    lbl_total_records: "Total des Enregistrements",
    lbl_present_rate: "Taux de Présence",
    lbl_date: "Date",
    lbl_name: "Nom",
    lbl_type: "Type",
    lbl_class_dept: "Classe/Dépt",
    lbl_level: "Niveau",
    lbl_shift: "Quart",
    lbl_status: "Statut",
    lbl_justification: "Justification",
    lbl_item: "Article",
    lbl_description: "Description",
    lbl_quantity: "Quantité",
    lbl_destination: "Destination",
    lbl_collector: "Collecteur",
    lbl_search_name: "Rechercher par Nom",
    ph_search_name: "Rechercher le nom...",

    auth_signin_title: "Connexion",
    auth_register_title: "Créer un Compte",
    auth_verify_title: "Vérifiez Votre Email",
    auth_back_home: "Retour à l'Accueil",
    auth_back_signin: "Retour à la connexion",
    auth_welcome: "Bienvenue sur le portail de Nation Ubuntu School",
    auth_register_desc: "Inscrivez-vous sur le portail de Nation Ubuntu School",
    lbl_email: "Email",
    lbl_password: "Mot de Passe",
    lbl_full_name: "Nom Complet",
    lbl_confirm_password: "Confirmer le Mot de Passe",
    lbl_account_type: "Type de Compte",
    opt_guardian: "Tuteur / Parent",
    opt_staff: "Personnel",
    opt_teacher: "Enseignant",
    opt_admin: "Admin (nécessite une approbation)",
    ph_email: "vous@exemple.com",
    ph_password: "Entrez votre mot de passe",
    ph_full_name: "Entrez votre nom complet",
    ph_create_password: "Créer un mot de passe (min 6 car.)",
    ph_confirm_password: "Ressaisissez votre mot de passe",
    ph_verify_code: "000000",
    lbl_verify_code: "Code de Vérification",
    verify_desc: "Entrez le code à 6 chiffres envoyé à",
    verify_hint: "Le code expire dans 10 minutes.",
    btn_sign_in: "Se Connecter",
    btn_signing_in: "Connexion...",
    btn_register: "S'inscrire",
    btn_sending: "Envoi...",
    btn_verify: "Vérifier et Créer le Compte",
    btn_verifying: "Vérification...",
    or_signin_with: "OU SE CONNECTER AVEC",
    no_account: "Vous n'avez pas de compte?",
    register_here: "Inscrivez-vous ici",
    have_account: "Vous avez déjà un compte?",
    signin_link: "Se connecter",
    resend_code: "Vous n'avez pas reçu de code? Renvoyer",
    admin_approval_note: "Les comptes Admin nécessitent une approbation. Un email sera envoyé à l'administrateur pour examen.",
    verify_code_note: "Un code de vérification sera envoyé à votre email. Vous devez le saisir dans les 10 minutes pour terminer l'inscription.",
    err_recaptcha: "Veuillez compléter la vérification reCAPTCHA.",
    err_invalid_credentials: "Email ou mot de passe invalide. Veuillez réessayer.",
    err_password_mismatch: "Les mots de passe ne correspondent pas. Veuillez confirmer votre mot de passe.",
    err_password_short: "Le mot de passe doit comporter au moins 6 caractères.",
    err_confirm_mismatch: "Les mots de passe ne correspondent pas.",
    err_passwords_match: "Les mots de passe correspondent",
    err_registration_failed: "Échec de l'inscription. Veuillez réessayer.",
    err_verification_failed: "Échec de la vérification.",
    err_resend_failed: "Échec du renvoi du code.",
    err_unexpected: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    err_unexpected_verify: "Une erreur inattendue s'est produite lors de la vérification.",
    err_google_signin: "Échec de la connexion Google. Veuillez réessayer.",
    err_facebook_signin: "Échec de la connexion Facebook. Veuillez réessayer.",
    msg_admin_request: "Demande d'approbation Admin envoyée! Un email a été envoyé à l'administrateur. Vous recevrez vos identifiants une fois approuvé.",
    msg_verify_sent: "Un code de vérification a été envoyé à votre email. Il expire dans 10 minutes.",
    msg_verify_code_prefix: "Votre code de vérification est:",
    msg_account_created: "Compte créé avec succès! Vous pouvez maintenant vous connecter.",
    msg_resend_sent: "Un nouveau code de vérification a été envoyé à votre email.",
    msg_resend_code_prefix: "Votre nouveau code de vérification est:",

    pw_change_title: "Changez Votre Mot de Passe",
    pw_change_desc: "C'est votre première connexion. Vous devez définir un nouveau mot de passe.",
    lbl_new_password: "Nouveau Mot de Passe",
    lbl_confirm_new_password: "Confirmer le Nouveau Mot de Passe",
    ph_new_password: "Entrez le nouveau mot de passe (min 6 car.)",
    ph_confirm_new_password: "Confirmez le nouveau mot de passe",
    btn_change_password: "Changer le Mot de Passe",
    btn_changing: "Modification...",
    pw_changed_title: "Mot de Passe Modifié!",
    pw_changed_desc: "Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant continuer à utiliser le portail.",
    btn_continue: "Continuer vers le Portail",
    err_change_password: "Échec du changement de mot de passe. Veuillez réessayer.",

    reg_title: "Nouvelle Inscription d'Élève",
    reg_desc: "Inscrivez un nouvel élève. Attribuez-lui une classe et un quart.",
    lbl_reg_name: "Nom Complet de l'Élève",
    lbl_reg_dob: "Date de Naissance",
    lbl_reg_gender: "Sexe",
    lbl_reg_level: "Niveau Demandé",
    lbl_reg_shift: "Quart",
    lbl_reg_class: "Attribuer à une Classe",
    lbl_reg_guardian: "Nom du Parent / Tuteur",
    lbl_reg_phone: "Téléphone / WhatsApp",
    lbl_reg_email: "Email du Tuteur (optionnel)",
    opt_level_preschool: "Pré-scolaire",
    opt_level_primary: "École Primaire",
    opt_level_secondary: "École Secondaire",
    opt_shift_morning: "Quart du Matin",
    opt_shift_afternoon: "Quart de l'Après-midi",
    opt_no_class: "Aucune classe attribuée",
    btn_submit_reg: "Soumettre l'Inscription",
    btn_saving: "Enregistrement...",
    reg_success_title: "Inscription Soumise avec Succès!",
    reg_ref_code: "Code de Référence",
    reg_success_msg: "L'élève a été inscrit et peut maintenant enregistrer sa présence.",
    err_reg_save: "Impossible d'enregistrer l'inscription. Veuillez réessayer.",
    reg_list_title: "Élèves Inscrits",
    reg_list_empty: "Aucun élève inscrit pour le moment.",
    ph_school_select: "Sélectionner une école...",
    ph_reg_name: "ex. Marie Uwase",
    ph_reg_guardian: "ex. Jean Bosco",
    ph_reg_phone: "+265...",
    ph_reg_email: "tuteur@exemple.com",

    dash_title: "Tableau de Bord Admin",
    dash_tab_overview: "Aperçu",
    dash_tab_attendance: "Suivi des Présences",
    dash_tab_activity: "Journal d'Activité",
    dash_total_students: "Total des Élèves",
    dash_total_volunteers: "Total des Bénévoles",
    dash_attendance_today: "Présences Aujourd'hui",
    dash_transfers: "Transferts",
    dash_recent_activity: "Activité Récente",
    dash_full_activity_log: "Journal d'Activité Complet",
    dash_no_activity: "Aucune activité enregistrée.",
    dash_no_attendance: "Aucun enregistrement de présence ne correspond aux filtres.",
    dash_no_logs: "Aucun journal d'activité trouvé.",
    dash_unknown: "Inconnu",
    dash_just_now: "à l'instant",
    dash_min_ago: "min ago",
    dash_hr_ago: "h ago",
    dash_day_ago: "j ago",
    ph_search_activity: "Rechercher par action, utilisateur, entité ou détails...",

    att_title: "Aperçu des Présences & Filtrage",
    att_desc: "Consultez et filtrez les enregistrements de présence. Les samedis et dimanches sont automatiquement ignorés.",
    att_filter_title: "Filtrer les Présences",
    att_lbl_class_level: "Niveau de Classe (Élèves)",
    att_lbl_dept_volunteers: "Département (Bénévoles)",
    att_loading: "Chargement des enregistrements de présence...",
    att_no_records: "Aucun enregistrement de présence trouvé avec les filtres actuels.",
    att_weekend: "Weekend (Ignoré)",
    opt_level_preschool_short: "Pré-scolaire",
    opt_level_primary_short: "Primaire",
    opt_level_secondary_short: "Secondaire",
    dept_sanitation: "Assainissement",
    dept_maintenance: "Maintenance",

    mgmt_tab_store: "Magasin",
    mgmt_tab_food: "Nourriture",
    mgmt_tab_media: "Média",
    mgmt_tab_transfers: "Transferts",
    mgmt_tab_schools: "Écoles",
    store_title: "Gestion du Magasin",
    store_entry_reg: "Enregistrement d'Entrée du Magasin",
    store_exit_reg: "Enregistrement de Sortie du Magasin",
    store_stock_title: "Stock (Inventaire Automatique: Entrées moins Sorties)",
    store_stock_desc: "Calculé automatiquement: stock = toutes les entrées du même article moins toutes les sorties.",
    store_no_inventory: "Aucune donnée d'inventaire disponible.",
    store_all_entries: "Tous les Articles Entrés",
    store_no_entries: "Aucune entrée enregistrée.",
    store_all_exits: "Tous les Articles Sortis",
    store_no_exits: "Aucune sortie enregistrée.",
    btn_entry: "Entrée",
    btn_exit: "Sortie",
    btn_stock: "Stock",
    btn_record_entry: "Enregistrer l'Entrée",
    btn_record_exit: "Enregistrer la Sortie",
    store_entries: "Entrées:",
    store_exits: "Sorties:",
    store_stock: "Stock:",
    ph_item: "ex. Cahiers",
    ph_desc: "ex. 100 pages rayées",
    ph_qty_num: "ex. 50",
    ph_dest: "ex. Primaire Grade 1",
    food_title: "Gestion de la Nourriture",
    food_ubuntu: "École Ubuntu",
    food_eagles: "École Eagles",
    food_bakery: "Boulangerie",
    food_ubuntu_title: "Distribution de Nourriture - École Ubuntu",
    food_eagles_title: "Distribution de Nourriture - École Eagles",
    food_bakery_title: "Gestion de la Boulangerie",
    lbl_item_meal: "Article / Repas",
    lbl_qty_str: "Quantité",
    lbl_receiver_details: "Bénéficiaire / Détails",
    btn_insert_ubuntu: "Insérer un Enregistrement Ubuntu",
    btn_insert_eagles: "Insérer un Enregistrement Eagles",
    btn_insert_bakery: "Insérer un Enregistrement Boulangerie",
    food_no_records: "Aucun enregistrement.",
    food_qty: "Qté:",
    food_details: "Détails:",
    food_item: "Article:",
    food_collector: "Collecteur:",
    food_date: "Date:",
    ph_food_ubuntu: "ex. Likuni Phala",
    ph_food_ubuntu_qty: "ex. 25 kg",
    ph_food_ubuntu_details: "ex. Enfants de pré-scolaire",
    ph_food_eagles: "ex. Riz & Haricots",
    ph_food_eagles_qty: "ex. 30 kg",
    ph_food_eagles_details: "ex. Élèves du primaire",
    ph_bakery_item: "ex. Pains",
    ph_bakery_qty: "ex. 50",
    ph_bakery_collector: "ex. Jean Dupont",
    media_title: "Gestion des Médias",
    media_entry_title: "Entrée d'Équipement Média",
    media_exit_title: "Sortie d'Équipement Média",
    media_inventory_title: "Inventaire Automatique (Entrée moins Sortie)",
    media_inventory_desc: "Calculé automatiquement à partir des entrées et sorties.",
    media_no_inventory: "Aucune donnée d'inventaire média.",
    media_no_entries: "Aucune entrée média.",
    media_no_exits: "Aucune sortie média.",
    btn_add_media_entry: "Ajouter une Entrée Média",
    btn_add_media_exit: "Ajouter une Sortie Média",
    btn_auto_inventory: "Inventaire Automatique",
    media_current_balance: "Solde Actuel:",
    ph_media_item: "ex. Caméras DSLR",
    ph_media_desc: "ex. Canon avec objectif",
    ph_media_qty: "ex. 3",
    transfers_title: "Transférer du Matériel Entre Écoles",
    transfers_desc: "Enregistrez le matériel transféré d'une école à une autre. Cela maintient l'inventaire de chaque école séparé.",
    lbl_from_school: "École Source",
    lbl_to_school: "École Destination",
    ph_select_source: "Sélectionner la source...",
    ph_select_dest: "Sélectionner la destination...",
    btn_record_transfer: "Enregistrer le Transfert",
    transfers_all: "Tous les Transferts",
    transfers_none: "Aucun transfert enregistré.",
    lbl_from: "De",
    lbl_to: "À",
    lbl_qty: "Qté",
    schools_title: "Gestion des Écoles",
    schools_desc: "Ajoutez et gérez les écoles. Les élèves et bénévoles inscrits dans une école sont séparés des autres.",
    lbl_school_name: "Nom de l'École",
    lbl_location: "Emplacement",
    lbl_school_desc: "Description",
    btn_add_school: "Ajouter une École",
    schools_all: "Toutes les Écoles",
    schools_none: "Aucune école ajoutée.",
    ph_school_name: "ex. Nation Ubuntu School",
    ph_location: "ex. Dzaleka - Dowa",
    ph_school_desc: "ex. Campus principal",

    // ── Academics (existing) ──
    reg_desc_old: "Veuillez remplir complètement le formulaire et télécharger les documents requis.",
    lbl_reg_photo: "Photo de l'Élève",
    lbl_photo_hint: "Photo portrait claire (JPG, PNG)",
    lbl_reg_id_doc: "Document d'Identification",
    lbl_id_hint: "Télécharger le scan ou photo d'identification",
    btn_submit_app: "Soumettre la Demande",
    reg_success_msg_old: "Vos documents ont été téléchargés en toute sécurité.",
    cert_title: "Authenticité des Certificats",
    cert_desc: "Vérifiez l'authenticité des certificats et téléchargez les bulletins.",
    lbl_certno: "Numéro de Série / ID du Rapport",
    lbl_doctype: "Type de Document",
    opt_report: "Bulletin Scolaire",
    opt_cert: "Certificat de Fin d'Études",
    opt_conduct: "Lettre de Recommandation",
    lbl_dlformat: "Format de Téléchargement",
    opt_pdf: "Document PDF Officiel",
    opt_seccopy: "Copie Sécurisée Certifiée",
    opt_printcopy: "Copie Prête pour Impression",
    btn_checkdoc: "Vérifier et Trouver",
    doc_verified: "Document Vérifié Authentique",
    doc_title: "Titre du Document",
    doc_title_val: "Certificat de Fin d'Études",
    doc_issued: "Délivré À",
    doc_issued_val: "Élève de la Nation Ubuntu",
    doc_stamp: "Cachet de l'Institution",
    doc_stamp_val: "Nation Ubuntu School - Camp de Dzaleka",
    btn_download_pdf: "Télécharger PDF",
    btn_download_copy: "Télécharger Copie Certifiée",
    msg_title: "Contacter l'Administration",
    lbl_recipient: "Envoyer À",
    opt_preschool: "Coordinateur Pré-scolaire",
    opt_primary: "Directeur de l'École Primaire",
    opt_secondary: "Directeur de l'École Secondaire",
    opt_safety: "Équipe de Sécurité",
    lbl_sendername: "Votre Nom Complet",
    lbl_contactinfo: "Téléphone ou E-mail",
    lbl_msgbody: "Contenu du Message",
    btn_sendmsg: "Envoyer le Message",
    sm_main_title: "Académique: Présences & Classes",
    sm_main_desc: "Gérez les départements par quart, les bénévoles, les classes et les présences.",
    sm_tab1: "1. Académique (Quart & Département)",
    sm_tab2: "2. Classes (Pré-scolaire & Primaire)",
    sm_tab3: "3. Intendance des Présences",
    acad_sub_title: "Quarts Académiques & Registres",
    lbl_acad_shift: "Sélectionner le Quart",
    lbl_acad_dept: "Sélectionner le Département",
    dept_admin: "Administration",
    dept_teachers_preschool: "Enseignants (Pré-scolaire)",
    dept_teachers_primary: "Enseignants (Primaire)",
    dept_psychosocial: "Psycho-social",
    dept_media: "Média",
    dept_safety: "Sécurité Scolaire",
    lbl_acad_worker: "Insérer le Nom du Bénévole",
    btn_add: "Ajouter",
    acad_roster_title: "Roster du Quart Actif",
    acad_all_names: "Tous les Noms",
    classes_sub_title: "Registres de Classes",
    lbl_class_session: "Sélectionner le Quart",
    lbl_class_level: "Sélectionner le Niveau",
    lbl_class_name: "Insérer le Nom de la Classe",
    btn_create_class: "Créer la Classe",
    lbl_active_class: "Sélectionner la Classe Active",
    lbl_teacher_name: "Nom de l'Enseignant",
    lbl_assistant_name: "Nom de l'Assistant",
    h4_add_student: "Insérer le Nom de l'Élève",
    btn_add_student: "Ajouter l'Élève",
    h4_student_register: "Registre des Élèves pour",
    house_sub_title: "Intendance des Présences",
    lbl_house_dept: "Sélectionner le Département",
    lbl_house_newdept: "Insérer le Nom du Département",
    btn_add_dept: "Ajouter Dépt",
    lbl_house_worker: "Insérer le Nom du Bénévole",
    btn_add_worker: "Ajouter Travailleur",
    h4_house_roster: "Roster d'Intendance pour",
    ph_certno: "ex. NUS-CERT-2025-998",
    ph_sendername: "Entrez votre nom complet",
    ph_contactinfo: "+265...",
    ph_msgbody: "Écrivez votre message ici...",
    ph_worker: "Entrez le nom du bénévole...",
    ph_classname: "ex. Classe A / Grade 1",
    ph_teacher: "Entrez le nom de l'enseignant...",
    ph_assistant: "Entrez le nom de l'assistant...",
    ph_student: "Entrez le nom de l'élève...",
    ph_dept: "Entrez le nouveau département...",
    ph_worker_h: "Entrez le nom du bénévole...",

    // ── HomePage ──
    hp_login: "Connexion",
    hp_portal_login: "Connexion au Portail",
    hp_learn_more: "En Savoir Plus",
    hp_hero_badge: "Fraternité Sans Frontières",
    hp_hero_title: "L'Éducation pour un Avenir Meilleur",
    hp_hero_desc: "Nation Ubuntu School est une institution éducative communautaire dans le camp de réfugiés de Dzaleka, dédiée à fournir une éducation de qualité de la pré-école au secondaire pour les enfants dans le besoin.",
    hp_stat_students: "Élèves Inscrits",
    hp_stat_levels: "Niveaux d'Éducation",
    hp_stat_volunteers: "Bénévoles",
    hp_stat_years: "Années de Service",
    hp_about_title: "À Propos de Notre École",
    hp_about_desc: "Située au cœur du camp de Dzaleka, nous servons les enfants réfugiés et locaux avec une éducation complète sur trois niveaux.",
    hp_preschool_title: "Pré-scolaire",
    hp_preschool_desc: "Éducation de la petite enfance qui construit les fondations de l'alphabétisation, de la numératie et des compétences sociales.",
    hp_primary_title: "École Primaire",
    hp_primary_desc: "Éducation primaire complète suivant un programme structuré qui prépare les élèves à l'éducation secondaire et au-delà.",
    hp_secondary_title: "École Secondaire",
    hp_secondary_desc: "Éducation secondaire avancée qui équipe les élèves de connaissances et de certificats pour poursuivre des études supérieures.",
    hp_mission_title: "Notre Mission & Nos Valeurs",
    hp_mission_desc: "Nous croyons que chaque enfant mérite l'accès à une éducation de qualité, quelles que soient ses circonstances.",
    hp_value_compassion: "Compassion",
    hp_value_compassion_desc: "Nous traitons chaque enfant avec dignité, gentillesse et respect, favorisant un environnement nourrissant.",
    hp_value_safety: "Sécurité",
    hp_value_safety_desc: "Nous fournissons un environnement sûr et protecteur où les enfants peuvent apprendre et s'épanouir sans crainte.",
    hp_value_community: "Communauté",
    hp_value_community_desc: "Nous construisons des partenariats solides avec les familles, bénévoles et organisations pour soutenir chaque élève.",
    hp_contact_title: "Contactez-Nous",
    hp_contact_desc: "Des questions sur l'inscription, les dons ou le bénévolat ? Nous serions ravis d'avoir de vos nouvelles.",
    hp_contact_loc1: "Dzaleka - Dowa",
    hp_contact_loc2: "P.O. Box 16, Malawi",
    hp_contact_email: "info@nationubuntu.org",
    hp_contact_hours1: "Lun - Ven",
    hp_contact_hours2: "7:00 AM - 4:00 PM",
    hp_access_portal: "Accéder au Portail",

    // ── Academics ──
    acad_title: "Académique: Présences & Classes",
    acad_desc: "Gérez les départements par quart, les bénévoles, les classes et les présences.",
    acad_attendance_date: "Date de Présence",
    acad_weekend_warning: "Week-end détecté - les présences sont ignorées les samedis et dimanches.",
    acad_btn_edit: "Modifier",
    acad_btn_delete: "Supprimer",
    acad_btn_present: "Présent",
    acad_btn_absent: "Absent",
    acad_btn_justified: "Justifié",
    acad_btn_not_justified: "Non Justifié",
    acad_no_workers: "Aucun bénévole/travailleur ajouté à",
    acad_no_workers2: "pour le quart",
    acad_no_workers3: "encore.",
    acad_no_students: "Aucun élève ajouté pour le moment.",
    acad_no_house_workers: "Aucun bénévole/travailleur ajouté à",
    acad_no_house_workers2: "encore.",
    acad_roster_shift: "Quart",
    acad_opt_morning: "Matin",
    acad_opt_afternoon: "Après-midi",
    acad_opt_preschool: "Pré-scolaire",
    acad_opt_primary: "Primaire",
    acad_btn_create: "Créer",
    acad_h4_add_student: "Ajouter un Élève",
    acad_student_register_none: "Aucune",
    acad_weekend_alert: "Les présences ne peuvent pas être enregistrées le week-end. Veuillez sélectionner un jour de semaine.",

    // ── PublicSections ──
    cert_alert: "Veuillez entrer un numéro de certificat / ID de rapport valide",
    cert_download_pdf_alert: "Préparation du téléchargement PDF officiel",
    cert_download_copy_alert: "Préparation du téléchargement de copie certifiée",
    msg_err_send: "Impossible d'envoyer le message. Veuillez réessayer.",
    msg_success_prefix: "Votre message a été envoyé au",
    msg_success_suffix: "Merci.",
    msg_btn_sending: "Envoi...",
    caravana_donate_monetary_alert: "Ouverture du portail de don sécurisé (Mobile Money / Virement bancaire / Carte de crédit via Fraternité Sans Frontières)...",
    caravana_donate_material_alert: "Merci! Veuillez préciser les dons de livres, uniformes ou équipements sportifs en contactant notre coordinateur logistique de Dzaleka.",
    caravana_donate_voluntary_alert: "Merci pour votre offre de service volontaire! Notre équipe Caravana vous contactera pour coordonner votre planning.",
    caravana_banner_title: "Caravana pour l'École",
    caravana_banner_sub: "Fraternité Sans Frontières - Initiative Nation Ubuntu School",
    caravana_what_title: "Qu'est-ce que le projet Caravana for School?",
    caravana_intro: "Le projet Caravana for School réunit des expatriés internationaux — Brésiliens, Américains et bénévoles du monde entier — qui se rendent à Dzaleka pour travailler aux côtés des éducateurs et élèves locaux. Leurs contributions incluent:",
    caravana_list1: "Enseignement Interactif & Activités Extrascolaires: Introduction aux arts créatifs, musique, langues et jeux d'apprentissage.",
    caravana_list2: "Renforcement des Capacités des Enseignants: Partage de techniques pédagogiques modernes et d'approches pédagogiques sensibles aux traumatismes.",
    caravana_list3: "Mobilisation des Ressources: Canalisation de fournitures scolaires, livres, équipements sportifs et contributions financières.",
    caravana_list4: "Programmation Sportive & Récréative: Utilisation de l'éducation physique structurée pour guérir les traumatismes et promouvoir la santé.",
    caravana_ubuntu_title: "La Philosophie d'Ubuntu en Action",
    caravana_ubuntu_desc: "Le cœur opérationnel de Caravana est la philosophie d'Ubuntu — \"Je suis parce que nous sommes.\"",
    caravana_pillars_title: "Piliers Fondamentaux",
    caravana_pillar1: "Combler les Lacunes de Ressources: En mobilisant des réseaux internationaux, le projet fournit des cahiers, manuels et outils d'apprentissage.",
    caravana_pillar2: "Élever l'Excellence des Éducateurs: Ateliers collaboratifs et mentorat par les pairs pour les enseignants locaux.",
    caravana_pillar3: "Favoriser le Bien-Être Psychosocial: L'apprentissage par le jeu, le sport et l'art offrent des exutoires psychologiques sûrs.",
    caravana_pillar4: "Élargir les Horizons Culturels: L'exposition à des bénévoles internationaux stimule l'ambition des élèves.",
    caravana_impact_title: "Impact Transformateur sur la Communauté",
    caravana_impact_desc: "L'impact du projet Caravana se propage dans toute la communauté. Les élèves montrent un engagement plus élevé et une confiance renouvelée.",
    caravana_conclusion_title: "Conclusion",
    caravana_conclusion_desc: "Le projet Caravana for School est une puissante manifestation de solidarité humaine et d'espoir actif.",
    caravana_support_title: "Soutenez Notre Mission - Choisissez le Type de Contribution",
    caravana_donate_monetary: "Don: Monétaire",
    caravana_donate_material: "Don: Matériel",
    caravana_voluntary: "Service Volontaire",

    // ── ExcelBulkUpload ──
    bulk_upload_btn: "Importation en Masse",
    bulk_upload_title: "Importation en Masse",
    bulk_upload_desc: "Téléchargez un fichier Excel (.xlsx ou .csv) pour enregistrer plusieurs entrées à la fois. Les colonnes doivent correspondre au modèle ci-dessous. Toutes les entrées seront enregistrées dans l'école sélectionnée.",
    bulk_download_template: "Télécharger le Modèle",
    bulk_template_desc: "Utilisez ce modèle pour que vos colonnes correspondent. Remplissez les lignes et téléchargez le fichier.",
    bulk_download_btn: "Télécharger le Modèle",
    bulk_drag_drop: "Glissez et déposez votre fichier Excel ici",
    bulk_or_browse: "ou cliquez pour parcourir",
    bulk_selected: "Sélectionné:",
    bulk_or_choose: "ou cliquez ci-dessous pour choisir un autre fichier",
    bulk_choose_file: "Choisir un Fichier",
    bulk_parsing: "Analyse de",
    bulk_preview: "Aperçu",
    bulk_rows: "lignes",
    bulk_valid: "valides",
    bulk_with_errors: "avec erreurs",
    bulk_status: "Statut",
    bulk_ok: "OK",
    bulk_upload_btn2: "Importer",
    bulk_to_database: "vers la Base de Données",
    bulk_uploading: "Importation...",
    bulk_select_school_warn: "Veuillez sélectionner une école avant l'importation.",
    bulk_success: "Enregistrés avec Succès",
    bulk_failed: "Échoués / Ignorés",
    bulk_errors: "Erreurs:",
    bulk_upload_another: "Importer un Autre Fichier",
    bulk_done: "Terminé",
    bulk_empty_file: "Le fichier Excel est vide ou ne contient aucune ligne de données.",
    bulk_read_error: "Impossible de lire le fichier Excel. Assurez-vous qu'il s'agit d'un fichier .xlsx ou .csv valide.",
    bulk_file_error: "Échec de la lecture du fichier.",
    bulk_db_error: "Erreur de base de données:",
    bulk_row: "Ligne",
    bulk_is_required: "est obligatoire",
    bulk_gender_err: "Le sexe doit être 'female' ou 'male'",
    bulk_level_err: "Le niveau doit être preschool, primary ou secondary",
    bulk_shift_err: "Le quart doit être 'morning' ou 'afternoon'",
    bulk_category_err: "La catégorie doit être 'academic' ou 'housekeeping'",
    bulk_col_full_name: "Nom Complet",
    bulk_col_dob: "Date de Naissance",
    bulk_col_gender: "Sexe",
    bulk_col_level: "Niveau",
    bulk_col_guardian_name: "Nom du Tuteur",
    bulk_col_guardian_phone: "Téléphone du Tuteur",
    bulk_col_guardian_email: "Email du Tuteur",
    bulk_col_shift: "Quart",
    bulk_col_department: "Département",
    bulk_col_category: "Catégorie",
    bulk_col_housekeeping_dept: "Dépt. Entretien",
    bulk_entity_student: "Élève",
    bulk_entity_volunteer: "Bénévole",
  },

  // ════════════════════════════ PORTUGUESE ════════════════════════════
  pt: {
    brand_loc: "Dzaleka - Dowa, P.O. Box 16, Malawi | Fraternidade Sem Fronteiras",
    footer_collab: "Em colaboração com",
    footer_copy: "© 2026 Nation Ubuntu School | Dzaleka - Dowa, P.O. Box 16 Malawi.",
    loading_portal: "Carregando o portal Nation Ubuntu School...",
    role_admin: "Administrador",
    role_staff: "Funcionário",
    role_teacher: "Professor",
    role_guardian: "Responsável",
    lang_en: "English",
    lang_fr: "Français",
    lang_pt: "Português (Brasil)",

    nav_reg: "Matrícula de Estudantes",
    nav_certs: "Certificados e Relatórios",
    nav_caravana: "Caravana para a Escola",
    nav_contact: "Contato e Segurança",
    nav_admin: "Gestão",
    nav_school_mgmt: "Acadêmico",
    nav_attendance: "Frequência",
    nav_dashboard: "Painel",
    nav_overview: "Visão Diária",
    nav_logout: "Sair",

    lbl_all: "Todos",
    lbl_all_schools: "Todas as Escolas",
    lbl_all_classes: "Todas as Turmas",
    lbl_all_departments: "Todos os Departamentos",
    lbl_select_school: "Selecionar Escola",
    lbl_person_type: "Tipo de Pessoa",
    lbl_gender: "Gênero",
    lbl_class: "Turma",
    lbl_department: "Departamento",
    lbl_date_from: "Data De",
    lbl_date_to: "Data Até",
    opt_female: "Feminino",
    opt_male: "Masculino",
    opt_students: "Estudantes",
    opt_volunteers: "Voluntários",
    opt_volunteers_staff: "Voluntários/Funcionários",
    btn_clear_filters: "Limpar Filtros",
    lbl_present: "Presente",
    lbl_absent: "Ausente",
    lbl_justified: "Justificado",
    lbl_total_records: "Total de Registros",
    lbl_present_rate: "Taxa de Presença",
    lbl_date: "Data",
    lbl_name: "Nome",
    lbl_type: "Tipo",
    lbl_class_dept: "Turma/Depto",
    lbl_level: "Nível",
    lbl_shift: "Turno",
    lbl_status: "Status",
    lbl_justification: "Justificativa",
    lbl_item: "Item",
    lbl_description: "Descrição",
    lbl_quantity: "Quantidade",
    lbl_destination: "Destino",
    lbl_collector: "Coletor",
    lbl_search_name: "Buscar por Nome",
    ph_search_name: "Buscar nome da pessoa...",

    auth_signin_title: "Entrar",
    auth_register_title: "Criar Conta",
    auth_verify_title: "Verifique Seu Email",
    auth_back_home: "Voltar ao Início",
    auth_back_signin: "Voltar ao login",
    auth_welcome: "Bem-vindo de volta ao portal Nation Ubuntu School",
    auth_register_desc: "Inscreva-se no portal Nation Ubuntu School",
    lbl_email: "Email",
    lbl_password: "Senha",
    lbl_full_name: "Nome Completo",
    lbl_confirm_password: "Confirmar Senha",
    lbl_account_type: "Tipo de Conta",
    opt_guardian: "Responsável / Pai",
    opt_staff: "Funcionário",
    opt_teacher: "Professor",
    opt_admin: "Admin (requer aprovação)",
    ph_email: "voce@exemplo.com",
    ph_password: "Digite sua senha",
    ph_full_name: "Digite seu nome completo",
    ph_create_password: "Crie uma senha (mín 6 car.)",
    ph_confirm_password: "Redigite sua senha",
    ph_verify_code: "000000",
    lbl_verify_code: "Código de Verificação",
    verify_desc: "Digite o código de 6 dígitos enviado para",
    verify_hint: "O código expira em 10 minutos.",
    btn_sign_in: "Entrar",
    btn_signing_in: "Entrando...",
    btn_register: "Inscrever-se",
    btn_sending: "Enviando...",
    btn_verify: "Verificar e Criar Conta",
    btn_verifying: "Verificando...",
    or_signin_with: "OU ENTRAR COM",
    no_account: "Não tem uma conta?",
    register_here: "Inscreva-se aqui",
    have_account: "Já tem uma conta?",
    signin_link: "Entrar",
    resend_code: "Não recebeu um código? Reenviar",
    admin_approval_note: "Contas Admin requerem aprovação. Um email será enviado ao administrador para revisão.",
    verify_code_note: "Um código de verificação será enviado ao seu email. Você deve inseri-lo em 10 minutos para concluir a inscrição.",
    err_recaptcha: "Por favor, complete a verificação reCAPTCHA.",
    err_invalid_credentials: "Email ou senha inválidos. Tente novamente.",
    err_password_mismatch: "As senhas não coincidem. Confirme sua senha.",
    err_password_short: "A senha deve ter pelo menos 6 caracteres.",
    err_confirm_mismatch: "As senhas não coincidem.",
    err_passwords_match: "As senhas coincidem",
    err_registration_failed: "Falha na inscrição. Tente novamente.",
    err_verification_failed: "Falha na verificação.",
    err_resend_failed: "Falha ao reenviar o código.",
    err_unexpected: "Ocorreu um erro inesperado. Tente novamente.",
    err_unexpected_verify: "Ocorreu um erro inesperado durante a verificação.",
    err_google_signin: "Falha no login do Google. Tente novamente.",
    err_facebook_signin: "Falha no login do Facebook. Tente novamente.",
    msg_admin_request: "Pedido de aprovação Admin enviado! Um email foi enviado ao administrador. Você receberá suas credenciais após aprovação.",
    msg_verify_sent: "Um código de verificação foi enviado ao seu email. Expira em 10 minutos.",
    msg_verify_code_prefix: "Seu código de verificação é:",
    msg_account_created: "Conta criada com sucesso! Você já pode fazer login.",
    msg_resend_sent: "Um novo código de verificação foi enviado ao seu email.",
    msg_resend_code_prefix: "Seu novo código de verificação é:",

    pw_change_title: "Altere Sua Senha",
    pw_change_desc: "Este é seu primeiro login. Você deve definir uma nova senha.",
    lbl_new_password: "Nova Senha",
    lbl_confirm_new_password: "Confirmar Nova Senha",
    ph_new_password: "Digite a nova senha (mín 6 car.)",
    ph_confirm_new_password: "Confirme a nova senha",
    btn_change_password: "Alterar Senha",
    btn_changing: "Alterando...",
    pw_changed_title: "Senha Alterada!",
    pw_changed_desc: "Sua senha foi atualizada com sucesso. Você já pode continuar usando o portal.",
    btn_continue: "Continuar para o Portal",
    err_change_password: "Falha ao alterar a senha. Tente novamente.",

    reg_title: "Nova Matrícula de Estudante",
    reg_desc: "Matricule um novo estudante. Atribua-o a uma turma e turno.",
    lbl_reg_name: "Nome Completo do Aluno",
    lbl_reg_dob: "Data de Nascimento",
    lbl_reg_gender: "Gênero",
    lbl_reg_level: "Nível Pretendido",
    lbl_reg_shift: "Turno",
    lbl_reg_class: "Atribuir à Turma",
    lbl_reg_guardian: "Nome do Responsável",
    lbl_reg_phone: "Telefone / WhatsApp",
    lbl_reg_email: "Email do Responsável (opcional)",
    opt_level_preschool: "Pré-Escola",
    opt_level_primary: "Ensino Fundamental",
    opt_level_secondary: "Ensino Médio",
    opt_shift_morning: "Turno da Manhã",
    opt_shift_afternoon: "Turno da Tarde",
    opt_no_class: "Nenhuma turma atribuída",
    btn_submit_reg: "Enviar Matrícula",
    btn_saving: "Salvando...",
    reg_success_title: "Matrícula Enviada com Sucesso!",
    reg_ref_code: "Código de Referência",
    reg_success_msg: "O estudante foi matriculado e já pode ter frequência registrada.",
    err_reg_save: "Não foi possível salvar a matrícula. Tente novamente.",
    reg_list_title: "Estudantes Matriculados",
    reg_list_empty: "Nenhum estudante matriculado ainda.",
    ph_school_select: "Selecionar uma escola...",
    ph_reg_name: "ex. Marie Uwase",
    ph_reg_guardian: "ex. Jean Bosco",
    ph_reg_phone: "+265...",
    ph_reg_email: "responsavel@exemplo.com",

    dash_title: "Painel do Administrador",
    dash_tab_overview: "Visão Geral",
    dash_tab_attendance: "Rastreador de Frequência",
    dash_tab_activity: "Registro de Atividades",
    dash_total_students: "Total de Estudantes",
    dash_total_volunteers: "Total de Voluntários",
    dash_attendance_today: "Frequência Hoje",
    dash_transfers: "Transferências",
    dash_recent_activity: "Atividade Recente",
    dash_full_activity_log: "Registro Completo de Atividades",
    dash_no_activity: "Nenhuma atividade registrada.",
    dash_no_attendance: "Nenhum registro de frequência corresponde aos filtros.",
    dash_no_logs: "Nenhum registro de atividade encontrado.",
    dash_unknown: "Desconhecido",
    dash_just_now: "agora mesmo",
    dash_min_ago: "min atrás",
    dash_hr_ago: "h atrás",
    dash_day_ago: "d atrás",
    ph_search_activity: "Buscar por ação, usuário, entidade ou detalhes...",

    att_title: "Visão Geral de Frequência e Filtragem",
    att_desc: "Visualize e filtre registros de frequência. Sábados e domingos são automaticamente ignorados.",
    att_filter_title: "Filtrar Frequência",
    att_lbl_class_level: "Nível da Turma (Estudantes)",
    att_lbl_dept_volunteers: "Departamento (Voluntários)",
    att_loading: "Carregando registros de frequência...",
    att_no_records: "Nenhum registro de frequência encontrado com os filtros atuais.",
    att_weekend: "Fim de Semana (Ignorado)",
    opt_level_preschool_short: "Pré-Escola",
    opt_level_primary_short: "Fundamental",
    opt_level_secondary_short: "Médio",
    dept_sanitation: "Saneamento",
    dept_maintenance: "Manutenção",

    mgmt_tab_store: "Armazém",
    mgmt_tab_food: "Alimentação",
    mgmt_tab_media: "Mídia",
    mgmt_tab_transfers: "Transferências",
    mgmt_tab_schools: "Escolas",
    store_title: "Gestão do Armazém",
    store_entry_reg: "Registro de Entrada do Armazém",
    store_exit_reg: "Registro de Saída do Armazém",
    store_stock_title: "Estoque (Inventário Automático: Entradas menos Saídas)",
    store_stock_desc: "Calculado automaticamente: estoque = todas as entradas do mesmo item menos todas as saídas.",
    store_no_inventory: "Nenhum dado de inventário disponível.",
    store_all_entries: "Todos os Itens de Entrada",
    store_no_entries: "Nenhuma entrada registrada.",
    store_all_exits: "Todos os Itens de Saída",
    store_no_exits: "Nenhuma saída registrada.",
    btn_entry: "Entrada",
    btn_exit: "Saída",
    btn_stock: "Estoque",
    btn_record_entry: "Registrar Entrada",
    btn_record_exit: "Registrar Saída",
    store_entries: "Entradas:",
    store_exits: "Saídas:",
    store_stock: "Estoque:",
    ph_item: "ex. Cadernos",
    ph_desc: "ex. 100 páginas pautadas",
    ph_qty_num: "ex. 50",
    ph_dest: "ex. Fundamental Série 1",
    food_title: "Gestão de Alimentação",
    food_ubuntu: "Escola Ubuntu",
    food_eagles: "Escola Eagles",
    food_bakery: "Padaria",
    food_ubuntu_title: "Distribuição de Alimentação - Escola Ubuntu",
    food_eagles_title: "Distribuição de Alimentação - Escola Eagles",
    food_bakery_title: "Gestão da Padaria",
    lbl_item_meal: "Item / Refeição",
    lbl_qty_str: "Quantidade",
    lbl_receiver_details: "Beneficiário / Detalhes",
    btn_insert_ubuntu: "Inserir Registro Ubuntu",
    btn_insert_eagles: "Inserir Registro Eagles",
    btn_insert_bakery: "Inserir Registro Padaria",
    food_no_records: "Nenhum registro.",
    food_qty: "Qtde:",
    food_details: "Detalhes:",
    food_item: "Item:",
    food_collector: "Coletor:",
    food_date: "Data:",
    ph_food_ubuntu: "ex. Likuni Phala",
    ph_food_ubuntu_qty: "ex. 25 kg",
    ph_food_ubuntu_details: "ex. Crianças da pré-escola",
    ph_food_eagles: "ex. Arroz & Feijão",
    ph_food_eagles_qty: "ex. 30 kg",
    ph_food_eagles_details: "ex. Estudantes do fundamental",
    ph_bakery_item: "ex. Pães",
    ph_bakery_qty: "ex. 50",
    ph_bakery_collector: "ex. João Silva",
    media_title: "Gestão de Mídia",
    media_entry_title: "Entrada de Equipamento de Mídia",
    media_exit_title: "Saída de Equipamento de Mídia",
    media_inventory_title: "Inventário Automático (Entrada menos Saída)",
    media_inventory_desc: "Calculado automaticamente com base nas entradas e saídas.",
    media_no_inventory: "Nenhum dado de inventário de mídia.",
    media_no_entries: "Nenhuma entrada de mídia.",
    media_no_exits: "Nenhuma saída de mídia.",
    btn_add_media_entry: "Adicionar Entrada de Mídia",
    btn_add_media_exit: "Adicionar Saída de Mídia",
    btn_auto_inventory: "Inventário Automático",
    media_current_balance: "Saldo Atual:",
    ph_media_item: "ex. Câmeras DSLR",
    ph_media_desc: "ex. Canon com lente",
    ph_media_qty: "ex. 3",
    transfers_title: "Transferir Material Entre Escolas",
    transfers_desc: "Registre material transferido de uma escola para outra. Isso mantém o inventário de cada escola separado.",
    lbl_from_school: "Escola de Origem",
    lbl_to_school: "Escola de Destino",
    ph_select_source: "Selecionar origem...",
    ph_select_dest: "Selecionar destino...",
    btn_record_transfer: "Registrar Transferência",
    transfers_all: "Todas as Transferências",
    transfers_none: "Nenhuma transferência registrada.",
    lbl_from: "De",
    lbl_to: "Para",
    lbl_qty: "Qtde",
    schools_title: "Gestão de Escolas",
    schools_desc: "Adicione e gerencie escolas. Estudantes e voluntários registrados em uma escola são mantidos separados dos outros.",
    lbl_school_name: "Nome da Escola",
    lbl_location: "Localização",
    lbl_school_desc: "Descrição",
    btn_add_school: "Adicionar Escola",
    schools_all: "Todas as Escolas",
    schools_none: "Nenhuma escola adicionada.",
    ph_school_name: "ex. Nation Ubuntu School",
    ph_location: "ex. Dzaleka - Dowa",
    ph_school_desc: "ex. Campus principal",

    // ── Academics (existing) ──
    reg_desc_old: "Por favor, preencha o formulário completamente e faça o upload dos documentos.",
    lbl_reg_photo: "Foto do Estudante",
    lbl_photo_hint: "Foto nítida do aluno (JPG, PNG)",
    lbl_reg_id_doc: "Documento de Identificação",
    lbl_id_hint: "Faça upload do documento de identificação",
    btn_submit_app: "Enviar Inscrição",
    reg_success_msg_old: "Seus documentos foram enviados com segurança.",
    cert_title: "Autenticidade de Certificados",
    cert_desc: "Verifique a veracidade dos certificados e baixe boletins.",
    lbl_certno: "Número de Série / ID do Relatório",
    lbl_doctype: "Tipo de Documento",
    opt_report: "Boletim Escolar",
    opt_cert: "Certificado de Conclusão",
    opt_conduct: "Carta de Recomendação",
    lbl_dlformat: "Formato de Download",
    opt_pdf: "Documento PDF Oficial",
    opt_seccopy: "Cópia Segura Certificada",
    opt_printcopy: "Cópia Pronta para Impressão",
    btn_checkdoc: "Verificar e Encontrar",
    doc_verified: "Documento Verificado Autêntico",
    doc_title: "Título do Documento",
    doc_title_val: "Certificado de Conclusão",
    doc_issued: "Emitido Para",
    doc_issued_val: "Estudante da Nation Ubuntu",
    doc_stamp: "Carimbo da Instituição",
    doc_stamp_val: "Nation Ubuntu School - Campo de Dzaleka",
    btn_download_pdf: "Baixar PDF",
    btn_download_copy: "Baixar Cópia Certificada",
    msg_title: "Mensagem à Administração",
    lbl_recipient: "Enviar Para",
    opt_preschool: "Coordenador da Pré-Escola",
    opt_primary: "Diretor do Ensino Fundamental",
    opt_secondary: "Diretor do Ensino Médio",
    opt_safety: "Equipe de Segurança",
    lbl_sendername: "Seu Nome Completo",
    lbl_contactinfo: "Telefone ou E-mail",
    lbl_msgbody: "Conteúdo da Mensagem",
    btn_sendmsg: "Enviar Mensagem",
    sm_main_title: "Acadêmico: Frequências & Turmas",
    sm_main_desc: "Gerencie departamentos por turno, voluntários, turmas e frequências.",
    sm_tab1: "1. Acadêmico (Turno & Departamento)",
    sm_tab2: "2. Turmas (Pré-Escola & Fundamental)",
    sm_tab3: "3. Frequência e Manutenção",
    acad_sub_title: "Turnos Acadêmicos & Registros",
    lbl_acad_shift: "Selecionar Turno",
    lbl_acad_dept: "Selecionar Departamento",
    dept_admin: "Administração",
    dept_teachers_preschool: "Professores (Pré-Escola)",
    dept_teachers_primary: "Professores (Fundamental)",
    dept_psychosocial: "Psicossocial",
    dept_media: "Mídia",
    dept_safety: "Segurança Escolar",
    lbl_acad_worker: "Inserir Nome de Voluntário",
    btn_add: "Adicionar",
    acad_roster_title: "Lista de Turno Ativo",
    acad_all_names: "Todos os Nomes",
    classes_sub_title: "Registros de Turmas",
    lbl_class_session: "Selecionar Turno",
    lbl_class_level: "Selecionar Nível",
    lbl_class_name: "Inserir Nome da Turma",
    btn_create_class: "Criar Turma",
    lbl_active_class: "Selecionar Turma Ativa",
    lbl_teacher_name: "Nome do Professor",
    lbl_assistant_name: "Nome do Professor Assistente",
    h4_add_student: "Inserir Nome do Estudante",
    btn_add_student: "Adicionar Estudante",
    h4_student_register: "Registro de Estudantes para",
    house_sub_title: "Frequência e Manutenção",
    lbl_house_dept: "Selecionar Departamento",
    lbl_house_newdept: "Inserir Nome do Departamento",
    btn_add_dept: "Adicionar Dept",
    lbl_house_worker: "Inserir Nome de Voluntário",
    btn_add_worker: "Adicionar Trabalhador",
    h4_house_roster: "Lista de Manutenção para",
    ph_certno: "ex. NUS-CERT-2025-998",
    ph_sendername: "Digite seu nome completo",
    ph_contactinfo: "+265...",
    ph_msgbody: "Escreva sua mensagem aqui...",
    ph_worker: "Digite o nome do voluntário...",
    ph_classname: "ex. Turma A / Série 1",
    ph_teacher: "Digite o nome do professor...",
    ph_assistant: "Digite o nome do assistente...",
    ph_student: "Digite o nome do estudante...",
    ph_dept: "Digite o novo departamento...",
    ph_worker_h: "Digite o nome do voluntário...",

    // ── HomePage ──
    hp_login: "Entrar",
    hp_portal_login: "Entrar no Portal",
    hp_learn_more: "Saiba Mais",
    hp_hero_badge: "Fraternidade Sem Fronteiras",
    hp_hero_title: "Educação para um Futuro Melhor",
    hp_hero_desc: "Nation Ubuntu School é uma instituição educacional comunitária no campo de refugiados de Dzaleka, dedicada a fornecer educação de qualidade da pré-escola ao ensino médio para crianças carentes.",
    hp_stat_students: "Estudantes Matriculados",
    hp_stat_levels: "Níveis de Educação",
    hp_stat_volunteers: "Voluntários",
    hp_stat_years: "Anos de Serviço",
    hp_about_title: "Sobre Nossa Escola",
    hp_about_desc: "Localizada no coração do campo de Dzaleka, servimos crianças refugiadas e locais com educação completa em três níveis.",
    hp_preschool_title: "Pré-Escola",
    hp_preschool_desc: "Educação infantil que constrói fundamentos de alfabetização, numeracia e habilidades sociais.",
    hp_primary_title: "Ensino Fundamental",
    hp_primary_desc: "Educação fundamental completa seguindo um currículo estruturado que prepara os alunos para o ensino médio.",
    hp_secondary_title: "Ensino Médio",
    hp_secondary_desc: "Educação secundária avançada que equipa os alunos com conhecimento e certificados para pursue higher education.",
    hp_mission_title: "Nossa Missão e Valores",
    hp_mission_desc: "Acreditamos que toda criança merece acesso a educação de qualidade, independentemente de suas circunstâncias.",
    hp_value_compassion: "Compaixão",
    hp_value_compassion_desc: "Tratamos cada criança com dignidade, bondade e respeito, promovendo um ambiente acolhedor.",
    hp_value_safety: "Segurança",
    hp_value_safety_desc: "Fornecemos um ambiente seguro e protetor onde as crianças podem aprender e prosperar sem medo.",
    hp_value_community: "Comunidade",
    hp_value_community_desc: "Construímos parcerias fortes com famílias, voluntários e organizações para apoiar cada estudante.",
    hp_contact_title: "Entre em Contato",
    hp_contact_desc: "Dúvidas sobre matrícula, doações ou voluntariado? Adoraríamos ouvir você.",
    hp_contact_loc1: "Dzaleka - Dowa",
    hp_contact_loc2: "P.O. Box 16, Malawi",
    hp_contact_email: "info@nationubuntu.org",
    hp_contact_hours1: "Seg - Sex",
    hp_contact_hours2: "7:00 - 16:00",
    hp_access_portal: "Acessar Portal",

    // ── Academics ──
    acad_title: "Acadêmico: Frequências e Turmas",
    acad_desc: "Gerencie departamentos por turno, voluntários, turmas e frequências.",
    acad_attendance_date: "Data de Frequência",
    acad_weekend_warning: "Fim de semana detectado - frequências são ignoradas aos sábados e domingos.",
    acad_btn_edit: "Editar",
    acad_btn_delete: "Excluir",
    acad_btn_present: "Presente",
    acad_btn_absent: "Ausente",
    acad_btn_justified: "Justificado",
    acad_btn_not_justified: "Não Justificado",
    acad_no_workers: "Nenhum voluntário/trabalhador adicionado a",
    acad_no_workers2: "para o turno",
    acad_no_workers3: "ainda.",
    acad_no_students: "Nenhum estudante adicionado ainda.",
    acad_no_house_workers: "Nenhum voluntário/trabalhador adicionado a",
    acad_no_house_workers2: "ainda.",
    acad_roster_shift: "Turno",
    acad_opt_morning: "Manhã",
    acad_opt_afternoon: "Tarde",
    acad_opt_preschool: "Pré-Escola",
    acad_opt_primary: "Fundamental",
    acad_btn_create: "Criar",
    acad_h4_add_student: "Adicionar Estudante",
    acad_student_register_none: "Nenhuma",
    acad_weekend_alert: "A frequência não pode ser registrada aos fins de semana. Selecione um dia útil.",

    // ── PublicSections ──
    cert_alert: "Por favor, insira um número de certificado / ID de relatório válido",
    cert_download_pdf_alert: "Preparando download do PDF oficial",
    cert_download_copy_alert: "Preparando download da cópia certificada",
    msg_err_send: "Não foi possível enviar a mensagem. Tente novamente.",
    msg_success_prefix: "Sua mensagem foi enviada para o",
    msg_success_suffix: "Obrigado.",
    msg_btn_sending: "Enviando...",
    caravana_donate_monetary_alert: "Abrindo Portal Seguro de Doação Monetária (Mobile Money / Transferência Bancária / Cartão de Crédito via Fraternidade Sem Fronteiras)...",
    caravana_donate_material_alert: "Obrigado! Especifique doações de livros, uniformes ou equipamentos esportivos contatando nosso coordenador logístico de Dzaleka.",
    caravana_donate_voluntary_alert: "Obrigado por se oferecer para o Serviço Voluntário! Nossa equipe Caravana entrará em contato.",
    caravana_banner_title: "Caravana para a Escola",
    caravana_banner_sub: "Fraternidade Sem Fronteiras - Iniciativa Nation Ubuntu School",
    caravana_what_title: "O que é o projeto Caravana for School?",
    caravana_intro: "O projeto Caravana for School une expatriados internacionais — brasileiros, americanos e voluntários do mundo todo — que viajam a Dzaleka para trabalhar com educadores e alunos locais. Suas contribuições incluem:",
    caravana_list1: "Ensino Interativo e Atividades Extracurriculares: Introdução a artes criativas, música, idiomas e jogos educativos.",
    caravana_list2: "Capacitação de Professores: Compartilhamento de técnicas pedagógicas modernas e abordagens sensíveis a traumas.",
    caravana_list3: "Mobilização de Recursos: Canalização de suprimentos escolares, livros, equipamentos esportivos e contribuições financeiras.",
    caravana_list4: "Programação Esportiva e Recreativa: Educação física estruturada para curar traumas e promover saúde.",
    caravana_ubuntu_title: "A Filosofia de Ubuntu em Ação",
    caravana_ubuntu_desc: "O coração operacional da Caravana é a filosofia de Ubuntu — \"Eu sou porque nós somos.\"",
    caravana_pillars_title: "Pilares Fundamentais",
    caravana_pillar1: "Preencher Lacunas de Recursos: Mobilizando redes internacionais, o projeto fornece cadernos, livros e ferramentas.",
    caravana_pillar2: "Elevar a Excelência dos Educadores: Oficinas colaborativas e mentoria para professores locais.",
    caravana_pillar3: "Promover Bem-Estar Psicossocial: Aprendizagem lúdica, esportes e arte fornecem saídas psicológicas seguras.",
    caravana_pillar4: "Expandir Horizontes Culturais: Exposição a voluntários internacionais desperta ambição nos estudantes.",
    caravana_impact_title: "Impacto Transformador na Comunidade",
    caravana_impact_desc: "O impacto do projeto Caravana se espalha por toda a comunidade. Os estudantes mostram maior engajamento e confiança renovada.",
    caravana_conclusion_title: "Conclusão",
    caravana_conclusion_desc: "O projeto Caravana for School é uma poderosa manifestação de solidariedade humana e esperança ativa.",
    caravana_support_title: "Apoie Nossa Missão - Escolha o Tipo de Contribuição",
    caravana_donate_monetary: "Doar: Monetário",
    caravana_donate_material: "Doar: Material",
    caravana_voluntary: "Serviço Voluntário",

    // ── ExcelBulkUpload ──
    bulk_upload_btn: "Importação em Massa",
    bulk_upload_title: "Importação em Massa",
    bulk_upload_desc: "Carregue um arquivo Excel (.xlsx ou .csv) para registrar várias entradas de uma vez. As colunas devem corresponder ao modelo abaixo. Todas as entradas serão salvas na escola selecionada.",
    bulk_download_template: "Baixar Modelo",
    bulk_template_desc: "Use este modelo para garantir que suas colunas correspondam. Preencha as linhas e carregue o arquivo.",
    bulk_download_btn: "Baixar Modelo",
    bulk_drag_drop: "Arraste e solte seu arquivo Excel aqui",
    bulk_or_browse: "ou clique para procurar",
    bulk_selected: "Selecionado:",
    bulk_or_choose: "ou clique abaixo para escolher outro arquivo",
    bulk_choose_file: "Escolher Arquivo",
    bulk_parsing: "Analisando",
    bulk_preview: "Pré-visualização",
    bulk_rows: "linhas",
    bulk_valid: "válidos",
    bulk_with_errors: "com erros",
    bulk_status: "Status",
    bulk_ok: "OK",
    bulk_upload_btn2: "Carregar",
    bulk_to_database: "para o Banco de Dados",
    bulk_uploading: "Carregando...",
    bulk_select_school_warn: "Por favor, selecione uma escola antes de carregar.",
    bulk_success: "Salvos com Sucesso",
    bulk_failed: "Falhados / Ignorados",
    bulk_errors: "Erros:",
    bulk_upload_another: "Carregar Outro Arquivo",
    bulk_done: "Concluído",
    bulk_empty_file: "O arquivo Excel está vazio ou não possui linhas de dados.",
    bulk_read_error: "Não foi possível ler o arquivo Excel. Certifique-se de que é um arquivo .xlsx ou .csv válido.",
    bulk_file_error: "Falha ao ler o arquivo.",
    bulk_db_error: "Erro de banco de dados:",
    bulk_row: "Linha",
    bulk_is_required: "é obrigatório",
    bulk_gender_err: "Gênero deve ser 'female' ou 'male'",
    bulk_level_err: "Nível deve ser preschool, primary ou secondary",
    bulk_shift_err: "Turno deve ser 'morning' ou 'afternoon'",
    bulk_category_err: "Categoria deve ser 'academic' ou 'housekeeping'",
    bulk_col_full_name: "Nome Completo",
    bulk_col_dob: "Data de Nascimento",
    bulk_col_gender: "Gênero",
    bulk_col_level: "Nível",
    bulk_col_guardian_name: "Nome do Responsável",
    bulk_col_guardian_phone: "Telefone do Responsável",
    bulk_col_guardian_email: "Email do Responsável",
    bulk_col_shift: "Turno",
    bulk_col_department: "Departamento",
    bulk_col_category: "Categoria",
    bulk_col_housekeeping_dept: "Depto. Limpeza",
    bulk_entity_student: "Estudante",
    bulk_entity_volunteer: "Voluntário",
  },
};

export function getLang(): Lang {
  return (localStorage.getItem("nus_lang") as Lang) || "en";
}

export function setLang(lang: Lang) {
  localStorage.setItem("nus_lang", lang);
}

export function t(key: string): string {
  const lang = getLang();
  return translations[lang]?.[key] ?? translations.en[key] ?? key;
}